import React, { useEffect, useState, useCallback, useRef } from "react";
import Routing from "./Routing";
import CToast from "../basecomp/components/CToast";
import { useToast } from "../basecomp/components/provider/ToastProvider";
import Header from "../basecomp/main/Header";
import Footer from "../basecomp/main/Footer";
import Services from "../basecomp/main/Services";
import UserUtils from "../basecomp/auth/UserUtils";
import LoginView from "../basecomp/auth/view/LoginView";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import ConasLogo from "./assets/conas_logo.png";
import ConasLogoSmall from "./assets/logo512.png";
import BgImg from "./assets/portbg_blur.png";
import warehouseimg from "../home/assets/warehouse.png";
import dcatimg from "../home/assets/d-catalogue.png";
import fuelimg from "../home/assets/f.png";
import glnimg from "../home/assets/gln.jpg";
import tariffimg from "../home/assets/tariff.png";
import materialimg from "./assets/matrequest.png";
import userimg from "./assets/user.jpg";
import xclupimg from "./assets/xclupload.jpg";
import devtoolimg from "./assets/devtools.png";
import monitor from "./assets/users.jpg";
import ticketing_tool from "./assets/ticketing_tool.png";
import usageTracker from './assets/usage-tracker.jpg'
import PrintingView from "../label_print/src/view/PrintingView";
import UploadLabelView from "../label_print/src/view/UploadLabelView";
import BinLocationView from "../label_print/src/view/BinLocationView";
import WareHouseView from "../label_print/src/view/WarehouseLocation";
import ImageUploadView from "../image_upload/src/view/ImageUploadView";
import RegistrationDataView from "../gsone/src/view/RegistrationView";
import SparePartInfoView from "../gsone/src/view/SparePartInfoView";
import FuelAssetInfoView from "../gsone/src/view/FuelAssetView";
import HistoricalJob from "../d_catalogue/src/hist_jobs/view/HistoricalJob";
import ShoppingBasket from "../d_catalogue/src/sp_basket/view/ShoppingBasket";
import HistoricalJobDetails from "../d_catalogue/src/hist_jobs/view/HistoricalJobDetails";
import VisitorTermsView from "../visitor_mgmt/src/view/VisitorTermsView";
import VisitorLoginView from "../visitor_mgmt/src/view/VisitorLoginView";
import VisitorFormView from "../visitor_mgmt/src/view/VisitorFormView";
import VisitorApprovalView from "../visitor_mgmt/src/view/VisitorApprovalView";
import VisitorGatepassView from "../visitor_mgmt/src/view/VisitorGatepassView";
import ForgotPasswordView from "../visitor_mgmt/src/view/ForgotPasswordView"
import AdminDashboardView from "../visitor_mgmt/src/view/AdminDashboardView";
import ApproverDashboardView from "../visitor_mgmt/src/view/ApproverDashboardView";
import SuperAdminDashboardView from "../visitor_mgmt/src/view/SuperAdminDashboardView"
import PasswordChangeComponent from "../visitor_mgmt/src/view/PasswordChangeComponent"
import dataprocessimg from "../home/assets/automation.jpg";
import DataOperationCentre from "../data_processing_automation/src/view/DataProcessingView";
import DataOperationCentreHistory from "../data_processing_automation/src/view/DataHistoryView";
import DetailedPage from "../data_processing_automation/src/view/DetailedPage";
import IfsProcessingView from "../ifs/src/view/IfsProcessingView";
import IfsHistoryView from "../ifs/src/view/IfsHistoryView"

import GLNView from "../gln/src/view/GLNView";
import GLNUploadView from "../gln/src/view/GLNUploadView";
import GLNManagement from "../gln/src/view/GLNManagement"
import Tariff from "../tariff/src/view/Tariff";
import mrp from "./assets/MRP_image.png";

// import ModifyUserView from "../user/src/view/ModifyUserView";
// import ListUserView from "../user/src/view/ListUserView";
// import PermissionView from "../user/src/view/PermissionView";
import PermissionDenied from "./Permission";
import MatRequestView from "../material_creation/src/view/MatRequestView";
import MatProcessView from "../material_creation/src/view/MatProcessView";
import UploadTemplatesView from "../material_creation/src/view/UploadTemplatesView";
import DCatalogueTerminal from "../dcatalogue/src/view/DcatalogueTerminal";
import MCTCommonFilesView from "../commonFiles/src/view/MCTCommonFilesView";
import ERPImplementationPage from "../home/src/ERPImplementation";
import HomePage from "../home/src//Home";
import MDMPage from "../home/src/MasterDataManagement";
import WarehousePage from "../home/src/WarehouseManagement";
import PowerBIPage from "../home/src/PowerBI";
import DCataloguePage from "../home/src/DCatalogue";
import FuelManagementPage from "../home/src/FuelManagement";
import DigitalLinkPage from "../home/src/DigitalLink";
import IndustryVerticlesPage from "../home/src/IndustryVerticles";
import AboutPage from "../home/src/About";
import ContactPage from "../home/src/Contact";
import New from "../home/src/New";
import Dashboard from "./dashboard/DashBoard";
import SessionHistory from "./dashboard/SessionHistory";
import UserManagement from "../user/src/view/UserManagementView";
import Permissions from "../user/src/view/PermissionView";
import DataManagement from "../user/src/view/DataManagementView";
import WareHouseCounting from "../label_print/src/view/WarehouseCounting";
import Maintenance_planning from "../maintenance_planning_tool/view/Maintenance_planning";
import {
  People as Users,
  Security as Shield,
  Storage as Database,
  Inventory2Outlined as InventoryIcon,
} from '@mui/icons-material';
import MCTDashboardView from "../material_creation/src/view/MCTDashboardView";
import AssetUploadView from "../conas_asset_it_resolver/src/view/AssetUploadView";
import AssetImageUpload from "../conas_asset_it_resolver/image_upload/src/view/AssetImageUpload";
import AssetDetailsView from "../conas_asset_it_resolver/src/view/AssetDetailsView";
import ResolverHeader from "../basecomp/main/ResolverHeader";
import MainLayout from "../Ticketing_Tool/view/MainLayout";
import MrpProcessingView from "../mrp_setting/src/view/mrpProcessingView";
import MrpHistoryView from "../mrp_setting/src/view/mrpHistoryView";

const AppContent = () => {
  const { handleLogin, handleLogout, getUserName, getInitials } = UserUtils;

  const currentUrl = window.location.href;
  const urlParams = new URL(currentUrl).searchParams;
  const loginParam = urlParams.get("login");
  const pathName = new URL(currentUrl).pathname;
  const isLoginReturn = loginParam === "true" && pathName === "/services";
  const localData = localStorage.getItem("permissionData");
  const feature_gln_download = localData
    ? localData.includes("feature_gln_download")
    : false;

  const [isReadyToRender, setIsReadyToRender] = useState(!isLoginReturn);

  const checkPermission = useCallback((permissionKey) => {
    const localData = localStorage.getItem("permissionData");
    if (!localData) return false;

    try {
      const permissionsArray = typeof localData === 'string'
        ? localData.split(',').map(p => p.trim())
        : localData;

      return permissionsArray.includes(permissionKey);
    } catch (error) {
      console.error('Error checking permission:', error);
      return false;
    }
  }, []);

  const isUAT = window.location.hostname.includes("uat");
  const routeUsageTracker =
    (isUAT
      ? process.env.REACT_APP_USAGE_TRACKER_URL_UAT
      : process.env.REACT_APP_USAGE_TRACKER_URL) +
    `?token=${localStorage.getItem("token")}`;


  const initialServices = useCallback(() => [
    {
      key: "tool_user",
      title: "User Management",
      route: "/users/user-management",
      asset: userimg,
    },
    {
      key: "tool_material",
      title: "Material Creation",
      route: "/material-creation/request-tracker",
      asset: materialimg,
    },
    {
      key: "tool_dcat",
      title: "D-Catalogue",
      route: "/d-catalogue/shopping-basket",
      asset: dcatimg,
    },
    {
      key: "tool_warehouse",
      title: "Warehouse",
      route: "/warehouse/label-printing",
      asset: warehouseimg,
    },
    {
      key: "tool_tariff",
      title: "Tariff Calculator",
      route: "/tariff/main",
      asset: tariffimg,
    },
    {
      key: "tool_gln",
      title: "Global Location Number / GLN",
      route: "/global-location-data/main",
      asset: glnimg,
    },
    {
      key: "tool_data",
      title: "Data Operations Centre",
      route: "/data-operation-centre",
      asset: dataprocessimg,
    },
    {
      key: "tool_ifs",
      title: "IFS Operations Centre",
      route: "/ifs-operation-centre",
      asset: dataprocessimg,
    },
    {
      key: "tool_gsone",
      title: "Resolver",
      route: "/warehouse/spare-part-info",
      asset: fuelimg,
    },
    {
      key: "tool_tracker",
      title: "Application Tracker Dashboard",
      route: "/dashboard/user",
      asset: monitor,
    },
    {
      key: "tool_asset_it",
      title: "Asset IT Resolver",
      route: "/asset-it/file-upload",
      asset: monitor,
    },
    {
      key: "tool_dev",
      title: "Database Management",
      route: "/dev-tools/data-management",
      asset: devtoolimg,
    },
    {
      key: "maintenance_planning",
      title: "Maintenance planning tool",
      route: `/maintenance_planning`,
      asset: xclupimg,
    },
    {
      key: "ticketing_tool",
      title: "Ticketing Tool",
      route: "/ticketing-tool",
      asset: ticketing_tool,
    },
    {
      key: "usage_tracker",
      title: "Application Usage Tracker",
      route: routeUsageTracker,
      asset: usageTracker,
      newTab: true
    },
    {
      key: "mrp_tool",
      title: "MRP Tool",
      asset: mrp,
      route:"/mrp_tool",
      newTab: true,
     
    }
  ], []);

  const [services, setServices] = useState([]);
  const [isPermissionLoaded, setIsPermissionLoaded] = useState(false);
  const [dataInitialized, setDataInitialized] = useState(false);

  const { handleToastOpen } = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPathName = location.pathname;
  const isHeader = !!currentPathName && currentPathName !== "/" && currentPathName !== "/login";

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [pendingRedirectPath, setPendingRedirectPath] = useState("");
  const [modalDismissed, setModalDismissed] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const preventModalRef = useRef(isLoginReturn);

  const userStateRef = useRef({
    userName: getUserName() || "",
    userInitials: getInitials() || "",
    isLoaded: !!(getUserName() && getInitials())
  });

  const [userState, setUserState] = useState(userStateRef.current);

  const checkIntervalRef = useRef(null);
  const pollingTimeoutRef = useRef(null);

  const [lastPermissionTimestamp, setLastPermissionTimestamp] = useState(null);
  const permissionSyncIntervalRef = useRef(null);
  const permissionSyncTimeoutRef = useRef(null);
  const broadcastChannelRef = useRef(null);

  const redirectProcessedRef = useRef(false);

  const forcePermissionRefresh = useCallback(async (maxRetries = 3) => {
    const token = localStorage.getItem("token");

    if (!token) {
      // console.log('No token found, skipping permission refresh');
      return false;
    }

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        // console.log(`Permission refresh attempt ${attempt}/${maxRetries}`);

        const response = await fetch('https://uatapi.conasservices.com/1.0.1/users/getLatestPermissions', {
          method: 'GET',
          headers: {
            'x-api-key': token,
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data && data.permissions && data.timestamp) {
          const currentPermissions = localStorage.getItem("permissionData");
          const currentTimestamp = localStorage.getItem("lastPermissionSync");

          const shouldUpdate = currentPermissions !== data.permissions ||
            !currentTimestamp ||
            new Date(data.timestamp) > new Date(currentTimestamp);

          if (shouldUpdate) {
            // console.log('Updating permissions:', data.permissions);

            localStorage.setItem("permissionData", data.permissions);
            localStorage.setItem("lastPermissionSync", data.timestamp);

            setLastPermissionTimestamp(data.timestamp);
            setIsPermissionLoaded(false);

            const customEvent = new Event('cStorage');
            window.dispatchEvent(customEvent);

            const storageEvent = new StorageEvent('storage', {
              key: 'permissionData',
              newValue: data.permissions,
              oldValue: currentPermissions
            });
            window.dispatchEvent(storageEvent);

            handleToastOpen("success", "Permissions updated successfully");

            return true;
          } else {
            // console.log('No permission changes detected');
            return true;
          }
        }

        return false;
      } catch (error) {
        console.error(`Permission refresh attempt ${attempt} failed:`, error);

        if (attempt < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, attempt * 1000));
        }
      }
    }

    console.error('All permission refresh attempts failed');
    handleToastOpen("error", "Failed to update permissions after multiple attempts");
    return false;
  }, [handleToastOpen]);

  const broadcastPermissionUpdate = useCallback(() => {
    // console.log('Broadcasting permission update to all tabs...');

    if (typeof BroadcastChannel !== 'undefined') {
      try {
        const channel = new BroadcastChannel('permission-updates');
        channel.postMessage({
          type: 'PERMISSION_UPDATE_REQUEST',
          timestamp: new Date().toISOString(),
          source: 'manual_trigger'
        });
        channel.close();
      } catch (error) {
        console.error('Error broadcasting permission update:', error);
      }
    }

    forcePermissionRefresh();
  }, [forcePermissionRefresh]);

  const refreshAllUserPermissions = useCallback(async () => {
    // console.log('Initiating comprehensive permission refresh...');

    broadcastPermissionUpdate();

    const success = await forcePermissionRefresh();

    // if (success) {
    //   console.log('Permission refresh completed successfully');
    // }

    return success;
  }, [broadcastPermissionUpdate, forcePermissionRefresh]);

  useEffect(() => {
    if (redirectProcessedRef.current) {
      return;
    }

    const currentUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);
    const hasLoginParam = urlParams.get("login") === "true";
    const isServicesPage = currentPathName === "/services";

    if (isAuthenticated && dataInitialized && isPermissionLoaded && isServicesPage && hasLoginParam) {
      const logingOneUrl = sessionStorage.getItem("logingsoneurl");

      // console.log('Processing redirect - logingOneUrl:', logingOneUrl);

      redirectProcessedRef.current = true;

      if (logingOneUrl) {
        // console.log('Redirecting to stored URL:', logingOneUrl);

        setTimeout(() => {
          try {
            let redirectPath = logingOneUrl;
            if (logingOneUrl.includes(window.location.origin)) {
              redirectPath = logingOneUrl.replace(window.location.origin, "");
            }

            if (!redirectPath.startsWith('/')) {
              redirectPath = '/' + redirectPath;
            }

            sessionStorage.removeItem("logingsoneurl");
            navigate(redirectPath, { replace: true });

          } catch (error) {
            console.error('Error during redirect:', error);
            sessionStorage.removeItem("logingsoneurl");
            navigate("/services", { replace: true });
          }
        }, 500);

      } else {
        // console.log('No redirect URL, cleaning up login param and staying on services');

        setTimeout(() => {
          navigate("/services", { replace: true });
        }, 800);
      }
    }
  }, [isAuthenticated, dataInitialized, isPermissionLoaded, currentPathName, navigate]);

  useEffect(() => {
    if (!isAuthenticated) {
      redirectProcessedRef.current = false;
    }
  }, [isAuthenticated]);

  const protectedRoutes = [
    "/services",
    "/data-operation-centre",
    "/material-creation/request-tracker",
    "/material-creation/process",
    "/material-creation/upload-templates",
    "/material-creation/pbidashboard",
    "/users/user-management",
    "/users/update-user",
    "/users/permission",
    "/users/data-management",
    "/warehouse/label-printing",
    "/warehouse/label-upload",
    "/warehouse/image-upload",
    "/warehouse/sap-bin-location",
    "/warehouse/spare-part-info",
    "/warehouse/asset-info",
    "/warehouse/registration-asset",
    "/warehouse/whs-location-info",
    "/d-catalogue/shopping-basket",
    "/d-catalogue/historical-job",
    "/d-catalogue/historical-job-detail",
    "/dashboard/user",
    "/dashboard/user/history",
    "/common-upload",
    "/d-cat-upload",
    "/global-location-data/main",
    "/global-location-data/upload",
    "/tariff/main",
    "/asset-it/file-upload",
    "/asset-it/image-upload",
    "/mrp_tool",
    "/mrp_tool/history"
  ];

  const isProtectedRoute = useCallback(() => {
    const isProtected = protectedRoutes.some(route =>
      currentPathName.startsWith(route) || currentPathName === route
    );

    return isProtected && !localStorage.getItem("token");
  }, [currentPathName]);

  const fetchLatestPermissions = useCallback(async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      return null;
    }

    try {
      const response = await fetch('https://uatapi.conasservices.com/1.0.1/users/getLatestPermissions', {
        method: 'GET',
        headers: {
          'x-api-key': token,
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching latest permissions:', error);
      return null;
    }
  }, []);

  const updatePermissions = useCallback((newPermissions, timestamp) => {
    const currentPermissions = localStorage.getItem("permissionData");

    if (currentPermissions !== newPermissions) {
      // console.log('Permissions updated:', newPermissions);

      localStorage.setItem("permissionData", newPermissions);

      setLastPermissionTimestamp(timestamp);
      localStorage.setItem("lastPermissionSync", timestamp);

      setIsPermissionLoaded(false);

      const customEvent = new Event('cStorage');
      window.dispatchEvent(customEvent);

      const storageEvent = new StorageEvent('storage', {
        key: 'permissionData',
        newValue: newPermissions,
        oldValue: currentPermissions
      });
      window.dispatchEvent(storageEvent);

      return true;
    }

    return false;
  }, []);

  const checkPermissionUpdates = useCallback(async () => {
    const latestData = await fetchLatestPermissions();

    if (latestData && latestData.permissions && latestData.timestamp) {
      const newTimestamp = latestData.timestamp;
      const currentTimestamp = localStorage.getItem("lastPermissionSync");

      if (!currentTimestamp || new Date(newTimestamp) > new Date(currentTimestamp)) {
        updatePermissions(latestData.permissions, newTimestamp);
      }
    }
  }, [fetchLatestPermissions, updatePermissions]);

  const startPermissionSync = useCallback(() => {
    if (permissionSyncIntervalRef.current) {
      clearInterval(permissionSyncIntervalRef.current);
    }
    if (permissionSyncTimeoutRef.current) {
      clearTimeout(permissionSyncTimeoutRef.current);
    }

    permissionSyncTimeoutRef.current = setTimeout(() => {
      checkPermissionUpdates();
    }, 2000);

    permissionSyncIntervalRef.current = setInterval(() => {
      checkPermissionUpdates();
    }, 15000);
  }, [checkPermissionUpdates]);

  const stopPermissionSync = useCallback(() => {
    if (permissionSyncIntervalRef.current) {
      clearInterval(permissionSyncIntervalRef.current);
      permissionSyncIntervalRef.current = null;
    }
    if (permissionSyncTimeoutRef.current) {
      clearTimeout(permissionSyncTimeoutRef.current);
      permissionSyncTimeoutRef.current = null;
    }
  }, []);

  const setupPermissionBroadcastListener = useCallback(() => {
    if (typeof BroadcastChannel !== 'undefined') {
      try {
        broadcastChannelRef.current = new BroadcastChannel('permission-updates');

        broadcastChannelRef.current.addEventListener('message', (event) => {
          if (event.data.type === 'PERMISSION_UPDATE_REQUEST') {
            // console.log('Received permission update broadcast from another tab');
            setTimeout(() => {
              forcePermissionRefresh();
            }, 500);
          }
        });

        // console.log('Permission broadcast listener setup complete');
      } catch (error) {
        console.error('Error setting up broadcast channel:', error);
      }
    }
  }, [forcePermissionRefresh]);

  const clearAllTimers = useCallback(() => {
    if (checkIntervalRef.current) {
      clearInterval(checkIntervalRef.current);
      checkIntervalRef.current = null;
    }
    if (pollingTimeoutRef.current) {
      clearTimeout(pollingTimeoutRef.current);
      pollingTimeoutRef.current = null;
    }
    stopPermissionSync();

    if (broadcastChannelRef.current) {
      broadcastChannelRef.current.close();
      broadcastChannelRef.current = null;
    }
  }, [stopPermissionSync]);

  const refreshUserInfo = useCallback(() => {
    const storedUserName = getUserName();
    const storedInitials = getInitials();

    if ((storedUserName !== userStateRef.current.userName ||
      storedInitials !== userStateRef.current.userInitials) &&
      (storedUserName && storedInitials)) {

      userStateRef.current = {
        userName: storedUserName,
        userInitials: storedInitials,
        isLoaded: true
      };

      setUserState(userStateRef.current);
      return true;
    }

    return !!userStateRef.current.isLoaded;
  }, []);

  const updateServicesPermissions = useCallback((forceUpdate = false) => {
    const localData = localStorage.getItem("permissionData");

    if (localData) {
      try {
        const permissionsArray = typeof localData === 'string'
          ? localData.split(',').map(p => p.trim())
          : localData;

        if (!isPermissionLoaded || forceUpdate) {
          const updatedServices = initialServices()
            .filter(service => permissionsArray.includes(service.key))
            .map(service => ({
              ...service,
              isEnabled: true,
              path: service.route
            }));

          setServices(updatedServices);
          setIsPermissionLoaded(true);
          // console.log('Services updated based on permissions:', updatedServices.map(s => s.key));
          return true;
        }
      } catch (error) {
        console.error('Error parsing permissions:', error);
        setServices([]);
        setIsPermissionLoaded(true);
        return true;
      }
    } else {
      setServices([]);
      setIsPermissionLoaded(true);
    }
    return isPermissionLoaded;
  }, [initialServices, isPermissionLoaded]);

  useEffect(() => {
    if (isLoginReturn) {
      const timer = setTimeout(() => {
        setIsReadyToRender(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [isLoginReturn]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const isAuth = !!token;

    setIsAuthenticated(isAuth);
    setIsInitialized(true);

    if (isLoginReturn) {
      setShowAuthModal(false);
      setModalDismissed(true);
      preventModalRef.current = true;
      return;
    }

    const hasLoginParam = loginParam === "true";
    const storedEmail = sessionStorage.getItem("email");
    const isLegitimateAuthFlow = hasLoginParam && storedEmail;

    if (isLegitimateAuthFlow) {
      setShowAuthModal(false);
      setModalDismissed(true);
      preventModalRef.current = true;
      return;
    }

    if (!isAuth && isProtectedRoute()) {
      if (currentPathName !== "/login") {
        const existingRedirectUrl = sessionStorage.getItem("logingsoneurl");
        if (!existingRedirectUrl) {
          sessionStorage.setItem("redirectAfterLogin", currentPathName);
        }

        setShowAuthModal(true);
        setPendingRedirectPath(currentPathName);
        navigate("/login", { replace: true });
      }
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'token' || e.type === 'cStorage' || e.key === 'permissionData') {
        const newToken = localStorage.getItem("token");
        const wasAuthenticated = isAuthenticated;
        const nowAuthenticated = !!newToken;

        if (!wasAuthenticated && nowAuthenticated) {
          preventModalRef.current = true;
          setIsAuthenticated(true);
          setShowAuthModal(false);
          setModalDismissed(true);
          setPendingRedirectPath("");

          if (isLoginReturn) {
            setIsReadyToRender(true);
          }

          const logingOneUrl = sessionStorage.getItem("logingsoneurl");
          const redirectPath = sessionStorage.getItem("redirectAfterLogin");

          if (logingOneUrl || redirectPath) {
            navigate("/services?login=true", { replace: true });
          } else {
            navigate("/services", { replace: true });
          }

        } else if (wasAuthenticated && !nowAuthenticated) {
          preventModalRef.current = false;
          setIsAuthenticated(false);
          setModalDismissed(false);
          redirectProcessedRef.current = false;

          sessionStorage.removeItem("logingsoneurl");
          sessionStorage.removeItem("redirectAfterLogin");

          if (isProtectedRoute()) {
            navigate("/login", { replace: true });
          }
        } else {
          setIsAuthenticated(nowAuthenticated);
        }

        if (e.key === 'permissionData' || e.type === 'cStorage') {
          updateServicesPermissions(true);
        }
      }
    };

    const handleCustomStorageChange = () => {
      handleStorageChange({ type: 'cStorage' });
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('cStorage', handleCustomStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('cStorage', handleCustomStorageChange);
    };
  }, [isAuthenticated, navigate, isProtectedRoute, isLoginReturn, updateServicesPermissions]);

  useEffect(() => {
    if (!isReadyToRender) return;

    if (isLoginReturn) {
      setShowAuthModal(false);
      return;
    }

    if (preventModalRef.current) {
      setShowAuthModal(false);
      return;
    }

    const token = localStorage.getItem("token");
    if (token || isAuthenticated) {
      setShowAuthModal(false);
      return;
    }

    if (currentPathName === "/login" && !modalDismissed) {
      const redirectPath = sessionStorage.getItem("redirectAfterLogin");
      if (redirectPath) {
        const timeoutId = setTimeout(() => {
          if (!localStorage.getItem("token") && !preventModalRef.current) {
            setShowAuthModal(true);
            setPendingRedirectPath(redirectPath);
          }
        }, 1000);

        return () => clearTimeout(timeoutId);
      }
    }
  }, [currentPathName, modalDismissed, isAuthenticated, isLoginReturn, isReadyToRender]);

  const handleAuthModalOk = () => {
    setShowAuthModal(false);
    setPendingRedirectPath("");
    setModalDismissed(true);
    preventModalRef.current = true;
    sessionStorage.clear();
    window.location.reload();
  };

  useEffect(() => {
    const checkAndLoadData = () => {
      const userDataLoaded = refreshUserInfo();
      const permissionDataLoaded = updateServicesPermissions();
      return userDataLoaded && permissionDataLoaded;
    };

    if (!checkAndLoadData() && !dataInitialized) {
      checkIntervalRef.current = setInterval(() => {
        if (checkAndLoadData()) {
          clearAllTimers();
          setDataInitialized(true);
        }
      }, 500);

      pollingTimeoutRef.current = setTimeout(() => {
        clearAllTimers();
        setDataInitialized(true);
      }, 5000);
    } else {
      setDataInitialized(true);
    }

    const handleStorageChange = () => {
      refreshUserInfo();
      updateServicesPermissions(true);
    };

    window.addEventListener("cStorage", handleStorageChange);

    setupPermissionBroadcastListener();

    return () => {
      window.removeEventListener("cStorage", handleStorageChange);
      clearAllTimers();
    };
  }, [refreshUserInfo, updateServicesPermissions, setupPermissionBroadcastListener, clearAllTimers, dataInitialized]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const email = sessionStorage.getItem("email");

    if (token && email && isAuthenticated) {
      const lastSync = localStorage.getItem("lastPermissionSync");
      if (!lastSync) {
        const now = new Date().toISOString();
        localStorage.setItem("lastPermissionSync", now);
        setLastPermissionTimestamp(now);
      } else {
        setLastPermissionTimestamp(lastSync);
      }

      startPermissionSync();
      setupPermissionBroadcastListener();
    } else {
      stopPermissionSync();
    }

    return () => {
      stopPermissionSync();
    };
  }, [isAuthenticated, startPermissionSync, stopPermissionSync, setupPermissionBroadcastListener]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && isAuthenticated) {
        setTimeout(() => {
          checkPermissionUpdates();
        }, 500);
      }
    };

    const handleFocus = () => {
      if (isAuthenticated) {
        setTimeout(() => {
          checkPermissionUpdates();
        }, 500);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, [isAuthenticated, checkPermissionUpdates]);

  useEffect(() => {
    window.refreshAllUserPermissions = refreshAllUserPermissions;
    window.forcePermissionRefresh = forcePermissionRefresh;
    window.broadcastPermissionUpdate = broadcastPermissionUpdate;

    if (process.env.NODE_ENV === 'development') {
      window.checkPermissionUpdates = checkPermissionUpdates;
    }

    return () => {
      delete window.refreshAllUserPermissions;
      delete window.forcePermissionRefresh;
      delete window.broadcastPermissionUpdate;
      if (process.env.NODE_ENV === 'development') {
        delete window.checkPermissionUpdates;
      }
    };
  }, [refreshAllUserPermissions, forcePermissionRefresh, broadcastPermissionUpdate, checkPermissionUpdates]);

  const appRouteMap = {
    "/home": {
      element: <HomePage />,
    },
    "/": {
      element: (
        <LoginView
          cLogo={ConasLogo}
          cBgImg={BgImg}
          handleToastOpen={() => handleToastOpen}
        />
      ),
    },
    "/login": {
      element: (
        <LoginView
          cLogo={ConasLogo}
          cBgImg={BgImg}
          handleToastOpen={() => handleToastOpen}
        />
      ),
    },
    "/services": {
      title: "Services",
      element: <Services services={services} linkComponent={Link} />,
    },
    "/ERP-Implementation": {
      element: <ERPImplementationPage />,
    },
    "/MDM": {
      element: <MDMPage />,
    },
    "/Warehouse": {
      element: <WarehousePage />,
    },
    "/PowerBI": {
      element: <PowerBIPage />,
    },
    "/DCatalogue": {
      element: <DCataloguePage />,
    },
    "/FuelManagement": {
      element: <FuelManagementPage />,
    },
    "/DigitalLink": {
      element: <DigitalLinkPage />,
    },
    "/IndustryVerticles": {
      element: <IndustryVerticlesPage />,
    },
    "/About": {
      element: <AboutPage />,
    },
    "/Contact": {
      element: <ContactPage />,
    },
    "/New": {
      element: <New />,
    },
    "/d-catalogue/historical-job": {
      title: "Historical Job",
      element: checkPermission("menu_dcat_histjobs") ? <HistoricalJob /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/d-catalogue/historical-job-detail": {
      title: "Historical Job Detail",
      element: checkPermission("menu_dcat_histjobs") ? <HistoricalJobDetails /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/d-catalogue/shopping-basket": {
      title: "Shopping Basket",
      element: checkPermission("menu_dcat_basket") ? <ShoppingBasket /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/dashboard/user": {
      title: "User Dashboard",
      element: checkPermission("tool_tracker") ? <Dashboard /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/dashboard/user/history": {
      title: "Session History",
      element: checkPermission("tool_tracker") ? <SessionHistory /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/users/user-management": {
      title: (
        <>
          <Users fontSize="large" style={{ marginRight: 8 }} />
          User Details
        </>
      ),
      element: checkPermission("menu_user_details") ? <UserManagement /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/users/permission": {
      title: (
        <>
          <Shield fontSize="large" style={{ marginRight: 8 }} />
          Permissions
        </>
      ),
      element: checkPermission("menu_user_permission") ? <Permissions /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/dev-tools/data-management": {
      title: (
        <>
          <Database fontSize="large" style={{ marginRight: 8 }} />
          Data Management
        </>
      ),
      element: (checkPermission("menu_dev_uat_db") || checkPermission("menu_dev_prod_db")) ? <DataManagement /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/asset-it/file-upload": {
      title: "Asset IT Resolver",
      element: <AssetUploadView />,
      isDrawer: true,
    },
    "/asset-it/image-upload": {
      title: "Asset Image Upload",
      element: < AssetImageUpload />,
      isDrawer: true,
    },
    "/asset": {
      title: "Asset IT Resolver",
      element: < AssetDetailsView />,
      isDrawer: false,
    },
    "/warehouse/label-printing": {
      title: "Label Printing",
      element: checkPermission("menu_warehouse_label") ? <PrintingView /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/warehouse/label-upload": {
      title: "Bulk Upload Labels ",
      element: checkPermission("menu_warehouse_bulk_upload") ? <UploadLabelView /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/warehouse/image-upload": {
      title: "Material Images Upload",
      element: checkPermission("menu_warehouse_img_upload") ? <ImageUploadView /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/warehouse/whs-location-info": {
      title: "WHS Location Info",
      element: checkPermission("menu_gsone_warehouse_resolver") ? <WareHouseView /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/warehouse/whs-location-info/counting": {
      title: "Material Counting",
      element: checkPermission("menu_gsone_warehouse_resolver") ? <WareHouseCounting /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/warehouse/sap-bin-location": {
      title: "Bin Location Details",
      element: checkPermission("menu_warehouse_bin_view") ? <BinLocationView /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/warehouse/registration-asset": {
      title: "Registration Data",
      element: checkPermission("menu_gsone_registration_asset") ? <RegistrationDataView /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/warehouse/spare-part-info": {
      title: "Spare Part Info",
      element: checkPermission("menu_gsone_product_resolver") ? <SparePartInfoView /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/warehouse/asset-info": {
      title: "Asset Info",
      element: checkPermission("menu_gsone_asset_resolver") ? <FuelAssetInfoView /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/global-location-data/main": {
      title: "Global Location Data",
      element: <GLNView />,
      // element: checkPermission("menu_gln_global_location_data") ? <GLNView /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/global-location-data/upload": {
      title: "Bulk Upload Data",
      element: <GLNUploadView />,
      // element: checkPermission("menu_gln_bulk_upload") ? <GLNUploadView /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/global-location-data/manage": {
      title: "Global Location Number Management",
      element: <GLNManagement />,
      isDrawer: true,
    },
    "/tariff/main": {
      title: "Tariff Digital Calculator",
      element: checkPermission("tool_tariff") ? <Tariff /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/visitor-mgmt": {
      title: "Visitor Management",
      element: <VisitorTermsView />,
      isDrawer: false,
    },
    "/visitor-mgmt/login": {
      element: <VisitorLoginView />,
      isDrawer: false,
    },
    "/visitor-mgmt/visitor-form": {
      element: <VisitorFormView />,
      isDrawer: false,
    },
    "/visitor-mgmt/approve-visitor/:id": {
      element: <VisitorApprovalView />,
      isDrawer: false,
    },
    "/visitor-mgmt/visitor-details": {
      element: <VisitorGatepassView />,
      isDrawer: false,
    },
    "/visitor-mgmt/visitor-details/:id": {
      element: <VisitorGatepassView />,
      isDrawer: false,
    },
    "/visitor-mgmt/admin-dashboard": {
      element: <AdminDashboardView />,
      isDrawer: false,
    },
    "/visitor-mgmt/super-admin-dashboard": {
      element: <SuperAdminDashboardView />,
      isDrawer: false,
    },
    "/visitor-mgmt/approver-dashboard": {
      element: <ApproverDashboardView />,
      isDrawer: false,
    },
    "/visitor-mgmt/change-password": {
      element: <PasswordChangeComponent />,
      isDrawer: false,
    },
    "/visitor-mgmt/forgot-password": {
      element: <ForgotPasswordView />,
      isDrawer: false,
    },
    "/material-creation/request-tracker": {
      title: "Material Request Tracker",
      element: checkPermission("menu_material_creation_tracker") ? <MatRequestView /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/material-creation/process/:id": {
      title: "Material Request Process",
      element: checkPermission("menu_material_creation_tracker") ? <MatProcessView /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/material-creation/pbidashboard": {
      title: "Material Creation Dashboard",
      element: checkPermission("menu_material_creation_dashboard") ? <MCTDashboardView /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/material-creation/upload-templates": {
      title: "Upload Templates",
      element: checkPermission("menu_material_creation_upload") ? <UploadTemplatesView /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/common-upload": {
      title: "Common Excel Upload",
      element: checkPermission("tool_dev") ? <MCTCommonFilesView /> : <PermissionDenied />,
    },
    "/d-cat-upload": {
      title: "D-Catalogue Upload",
      element: checkPermission("menu_dcat_cat_det") ? <DCatalogueTerminal /> : <PermissionDenied />,
    },
    "/data-operation-centre": {
      title: "Data Operations Centre",
      element: checkPermission("tool_data") ? <DataOperationCentre /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/data-operation-centre/history": {
      title: "Data Operations Centre",
      element: checkPermission("tool_data") ? <DataOperationCentreHistory /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/data-operation-centre/detail-history": {
      title: "Data Operations Centre",
      element: checkPermission("tool_data") ? <DetailedPage /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/ifs-operation-centre": {
      title: "IFS Operations Centre",
      element: checkPermission("tool_ifs") ? <IfsProcessingView /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/ifs-operation-centre/history": {
      title: "IFS Operations Centre",
      element: checkPermission("tool_ifs") ? <IfsHistoryView /> : <PermissionDenied />,
      isDrawer: false,
    },
    "/maintenance_planning": {
      title: "Maintenance Planning Tool",
      element: checkPermission("maintenance_planning") ? <Maintenance_planning /> : <PermissionDenied />,
      isDrawer: true,
    },
    "/ticketing-tool": {
      title: "Conas Ticketing Tool",
      element: <MainLayout />,
      isDrawer: false,
    },
     "/mrp_tool": {
      title: (
        <>
          <InventoryIcon fontSize="large" style={{ marginRight: 8 }} />
          Material Resource Planning Tool
        </>
      ),
       element: <MrpProcessingView />,
      isDrawer: false,
    },
    "/mrp_tool/history": {
      title: (
        <>
          <InventoryIcon fontSize="large" style={{ marginRight: 8 }} />
          MRP Tool History
        </>
      ),
      element: checkPermission("mrp_tool") ? <MrpHistoryView /> : <PermissionDenied />,
      isDrawer: false,
    },
  };

  const drawerList = [
    "/warehouse",
    "/d-catalogue",
    "/users",
    "/material-creation",
    "/global-location-data",
    "/asset-it",
    ...(feature_gln_download ? ["/global-location-data"] : []),
  ];

  const [pageTitle, setPageTitle] = useState("");

  useEffect(() => {
    const pathname = location.pathname;
    let title = "";
    if (appRouteMap[pathname]) {
      title = appRouteMap[pathname].title;
    } else {
      title = "";
    }
    setPageTitle(title);
  }, [location.pathname]);

  // Don't render anything until initialization is complete
  if (!isInitialized || (isLoginReturn && !isReadyToRender)) {
    return null;
  }

  const shouldShowHeader = isHeader && userState.isLoaded;

  // Modal condition
  const storedEmail = sessionStorage.getItem("email");
  const hasLoginParam = loginParam === "true";
  const isLegitimateAuthFlow = hasLoginParam && storedEmail;
  const shouldShowModal = isReadyToRender && !isLegitimateAuthFlow && showAuthModal && !preventModalRef.current && !isAuthenticated;

  return (
    <>
      {/* Authentication Modal */}
      <Dialog
        open={shouldShowModal}
        onClose={() => { }}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            borderRadius: 4,
            padding: 3,
            boxShadow: '0 12px 40px rgba(0,0,0,0.4)',
            border: 'none',
            background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
          }
        }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            backdropFilter: 'blur(4px)',
          }
        }}
      >
        <DialogTitle sx={{
          textAlign: "center",
          fontWeight: "700",
          fontSize: "1.5rem",
          color: "#1565c0",
          pb: 2,
          pt: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2
        }}>
          <span style={{ fontSize: '2rem' }}>🔒</span>
          Authentication Required
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", py: 3 }}>
          <Typography variant="body1" sx={{
            mb: 3,
            color: "#475569",
            fontSize: "1.1rem",
            lineHeight: 1.6,
            fontWeight: "400"
          }}>
            You need to be logged in to access this page. Please log in to continue.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 4, pt: 2 }}>
          <Button
            onClick={handleAuthModalOk}
            variant="contained"
            size="large"
            sx={{
              borderRadius: 3,
              px: 6,
              py: 1.5,
              fontSize: "1.1rem",
              fontWeight: "600",
              textTransform: "none",
              background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
              boxShadow: '0 6px 20px rgba(25, 118, 210, 0.4)',
              border: '1px solid rgba(255,255,255,0.2)',
              '&:hover': {
                background: 'linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)',
                boxShadow: '0 8px 25px rgba(25, 118, 210, 0.5)',
                transform: 'translateY(-1px)',
              },
              transition: 'all 0.3s ease'
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {shouldShowHeader ? (
        <Header
          cLogo={ConasLogo}
          cLogoSmall={ConasLogoSmall}
          handleLogin={handleLogin}
          handleLogout={handleLogout}
          cUserName={userState.userName}
          cUserInitials={userState.userInitials}
          pageTitle={pageTitle}
          appRouteMap={appRouteMap}
          drawerList={drawerList}
          pathName={currentPathName}
          navigate={navigate}
          linkComponent={Link}
        />
      ) : (isHeader ? <ResolverHeader
        cLogo={ConasLogo}
        cLogoSmall={ConasLogoSmall}
        handleLogin={handleLogin}
        handleLogout={handleLogout}
        cUserName={userState.userName}
        cUserInitials={userState.userInitials}
        pageTitle={pageTitle}
        appRouteMap={appRouteMap}
        drawerList={drawerList}
        pathName={currentPathName}
        navigate={navigate}
        linkComponent={Link}
      /> : '')}
      <CToast />
      <Routing appRouteMap={appRouteMap} />
    </>
  );
};

export default AppContent;

